import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import React from 'react';

import Spacer, { spc } from '../base/spacer';

interface BreadcrumbSkeletonProps {
  compact?: boolean;
}

export const LandingBreadcrumbSkeleton: React.FC<BreadcrumbSkeletonProps> = ({
  compact,
}) => {
  if (compact) {
    return <Skeleton variant="text" width={160} height={24} />;
  }

  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}
    >
      <Skeleton variant="text" width={180} height={28} />
      <Skeleton variant="text" width={16} height={28} />
      <Skeleton variant="text" width={140} height={28} />
    </Box>
  );
};

/**
 * Generic content-area skeleton shown while project-scoped dashboard data loads.
 */
const LandingContentSkeleton: React.FC = () => {
  return (
    <Box aria-busy aria-label="Loading page content">
      <Skeleton variant="text" width="min(320px, 60%)" height={40} />
      <Spacer pb={spc.s} />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={56}
        sx={{ borderRadius: 1 }}
      />
      <Spacer pb={spc.s} />
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: 3,
        }}
      >
        {[0, 1, 2].map((idx) => (
          <Skeleton
            key={idx}
            variant="rectangular"
            height={180}
            sx={{ borderRadius: 1 }}
          />
        ))}
      </Box>
      <Spacer pb={spc.s} />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={280}
        sx={{ borderRadius: 1 }}
      />
    </Box>
  );
};

export default LandingContentSkeleton;
